import React, { useEffect, useState } from 'react';
import { ChevronLeft, ArrowRight, BookOpen } from 'lucide-react';
import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export function VideoTutorialPlayer({ video, hasNext, onNext, onPractice, onBack }) {
  const [hasError, setHasError] = useState(false);

  // Resetear el estado de error cuando cambia el vídeo activo.
  useEffect(() => {
    setHasError(false);
  }, [video.id, video.url]);

  return (
    <div className="flex flex-col gap-4">
      <DialogHeader className="pt-6 text-center">
        <DialogTitle className="text-center">{video.title}</DialogTitle>
        <DialogDescription className="text-center">{video.description}</DialogDescription>
      </DialogHeader>

      <div className="flex justify-center">
        <video
          controls
          playsInline
          preload="metadata"
          poster={video.poster}
          src={video.url}
          onError={() => setHasError(true)}
          onLoadedMetadata={() => setHasError(false)}
          className="max-h-[70vh] max-w-full rounded-md bg-black"
        />
      </div>

      {hasError && (
        <p className="text-sm text-muted-foreground">
          No se ha podido cargar el vídeo. Comprueba tu conexión e inténtalo de nuevo.
        </p>
      )}

      <div className="flex flex-col gap-2">
        {hasNext && onNext && (
          <Button type="button" onClick={onNext} className="w-full">
            Siguiente videotutorial
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        )}

        {onPractice && (
          <Button type="button" variant="outline" onClick={onPractice} className="w-full">
            <BookOpen className="mr-2 h-4 w-4" />
            Practicar lo aprendido
          </Button>
        )}

        <Button type="button" variant="ghost" onClick={onBack} className="w-full">
          <ChevronLeft className="mr-2 h-4 w-4" />
          Volver a Tutoriales
        </Button>
      </div>
    </div>
  );
}